import { IconProps } from "../../utils/global-types/global-types";

const AgentsIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <g clipPath="url(#clip0_9739_115043)">
      <path
        fill="currentColor"
        d="M16.875 9.563v1.687a2.81 2.81 0 0 1-2.812 2.813H13.5a1.687 1.687 0 0 1-1.687-1.688V8.438A1.687 1.687 0 0 1 13.5 6.75h.529a5.063 5.063 0 0 0-10.058 0H4.5a1.69 1.69 0 0 1 1.688 1.688v3.937a1.69 1.69 0 0 1-1.125 1.586v.664a.56.56 0 0 0 .562.563h2.408a1.125 1.125 0 1 1 0 1.124H5.625a1.687 1.687 0 0 1-1.687-1.687v-.562a2.81 2.81 0 0 1-2.813-2.813V9.563A2.81 2.81 0 0 1 2.813 6.98a6.188 6.188 0 0 1 12.34 0 2.81 2.81 0 0 1 1.722 2.582"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_9739_115043">
        <path fill="currentColor" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default AgentsIcon;
